import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=2cb2a478&scoped=true&"
var script = {}
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=2cb2a478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2a478",
  null
  
)

export default component.exports